export default __webpack_public_path__ + "static/media/boy1.20ffe9a0.svg";